import { Component, Input, HostBinding } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'pagination-button',
  templateUrl: 'pagination-button.component.html',
  styleUrls: ['pagination-button.component.scss'],
})
export class PaginationButtonComponent {
  @Input() next: boolean = true;

  @HostBinding('class.disabled')
  @Input() disabled: boolean = false;
}
